import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { matchingPasswords } from '../../theme/utils/app-validators';
import { AppSettings } from '../../app.settings';

@Component({ standalone:false,
  selector: 'app-change-password-dialog',
  templateUrl: 'change-password-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['change-password-dialog.component.scss']
})
export class ChangePasswordDialogComponent {
  title: string= "Change Password";
  message: string = "";
  confirmButtonText = "Change";
  cancelButtonText = "Cancel";

  public hide = true;

  public dialogForm: FormGroup; 

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private appSettings:AppSettings, private dialogRef: MatDialogRef<ChangePasswordDialogComponent>) {
    if(data){
        this.title=data.title;
        this.message = data.message || this.message;
        if (data.buttonText) {
            this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
            this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
    }
    this.dialogForm = new FormGroup({
      password: new FormControl('', [Validators.required, Validators.pattern(this.appSettings.passwordRegex)]),
      confirmPassword: new FormControl('', Validators.required),
    },{validators: [matchingPasswords]});
  }


  get passwordAllowedSpecialCharacters(){
    return this.appSettings.passwordAllowedSpecialCharacters;
  }
  
  onConfirmClick(): void {
    if (this.dialogForm.valid) {
      this.dialogRef.close(this.dialogForm.get('password')!.value);
    }
  }
  onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

}